export default "__VITE_ASSET__B2CN7Sw3__"